'use client';

import React from 'react';

const clubStats = [
  { label: 'Active Members', value: '184', icon: '👥' },
  { label: 'Events Hosted', value: '32', icon: '🎯' },
  { label: 'Certifications', value: '97', icon: '🏆' },
  { label: 'Avg. Points', value: '218', icon: '⭐' },
];

const recentActivity = [
  { name: 'Priya Nair', action: 'earned Cloud Explorer badge', time: '2m ago', color: '#a78bfa' },
  { name: 'Karthik Rao', action: 'completed AWS Solutions Architect', time: '18m ago', color: '#22d3ee' },
  { name: 'Ananya Sharma', action: 'joined the club', time: '1h ago', color: '#34d399' },
  { name: 'Rohan Mehta', action: 'attended ML on AWS workshop', time: '3h ago', color: '#fbbf24' },
];

export default function AuthBrandPanel() {
  return (
    <div
      className="flex-1 flex flex-col justify-between p-10 xl:p-14 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #0f0f1a 0%, #1a0a2e 50%, #0a1a2e 100%)' }}
    >
      {/* Animated background nodes */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute w-64 h-64 rounded-full opacity-20 node-float"
          style={{
            background: 'radial-gradient(circle, #7c3aed 0%, transparent 70%)',
            top: '10%',
            right: '15%',
          }}
        />
        <div
          className="absolute w-48 h-48 rounded-full opacity-15"
          style={{
            background: 'radial-gradient(circle, #06b6d4 0%, transparent 70%)',
            bottom: '20%',
            left: '5%',
            animation: 'nodeFloat 8s ease-in-out infinite',
            animationDelay: '2s',
          }}
        />
        <div
          className="absolute w-32 h-32 rounded-full opacity-10"
          style={{
            background: 'radial-gradient(circle, #a78bfa 0%, transparent 70%)',
            top: '50%',
            left: '40%',
            animation: 'nodeFloat 10s ease-in-out infinite',
            animationDelay: '4s',
          }}
        />
        {/* Grid dots */}
        <svg className="absolute inset-0 w-full h-full opacity-5" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="auth-grid" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
              <circle cx="1" cy="1" r="1" fill="#a78bfa" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#auth-grid)" />
        </svg>
      </div>
      {/* Logo + title */}
      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-6">
          <div
            className="w-12 h-12 rounded-2xl flex items-center justify-center"
            style={{ background: 'var(--primary)', boxShadow: '0 0 24px rgba(124,58,237,0.5)' }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
            </svg>
          </div>
          <div>
            <p className="font-bold text-base" style={{ color: 'var(--foreground)' }}>
              AWS Club Portal
            </p>
            <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
              Student Builder Group
            </p>
          </div>
        </div>

        <h1 className="text-4xl xl:text-5xl font-800 leading-tight mb-4">
          <span style={{ color: 'var(--foreground)' }}>Build on </span>
          <span className="text-gradient-purple">AWS.</span>
          <br />
          <span style={{ color: 'var(--foreground)' }}>Grow </span>
          <span style={{ color: 'var(--secondary-foreground)' }}>Together.</span>
        </h1>
        <p className="text-base leading-relaxed max-w-sm" style={{ color: 'var(--muted-foreground)' }}>
          Track your cloud journey, earn badges, compete on the leaderboard, and stay connected with every AWS event at your campus.
        </p>
      </div>
      {/* Stats grid */}
      <div className="relative z-10 grid grid-cols-2 gap-3 my-8">
        {clubStats?.map((stat) => (
          <div
            key={`stat-${stat?.label}`}
            className="rounded-xl p-4 card-glass"
          >
            <div className="text-2xl mb-1">{stat?.icon}</div>
            <p
              className="text-2xl font-bold numeric-tabular"
              style={{ color: 'var(--foreground)' }}
            >
              {stat?.value}
            </p>
            <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
              {stat?.label}
            </p>
          </div>
        ))}
      </div>
      {/* Recent activity feed */}
      <div className="relative z-10">
        <p
          className="text-xs font-600 uppercase tracking-widest mb-3"
          style={{ color: 'var(--muted-foreground)', letterSpacing: '0.08em', fontSize: '10px' }}
        >
          Recent Activity
        </p>
        <div className="space-y-2">
          {recentActivity?.map((item, i) => (
            <div
              key={`activity-${i}`}
              className="flex items-center gap-3 px-3 py-2 rounded-lg card-glass"
            >
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
                style={{ background: `${item?.color}22`, color: item?.color, border: `1px solid ${item?.color}44` }}
              >
                {item?.name?.charAt(0)}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs truncate" style={{ color: 'var(--foreground)' }}>
                  <span className="font-600">{item?.name}</span>{' '}
                  <span style={{ color: 'var(--muted-foreground)' }}>{item?.action}</span>
                </p>
              </div>
              <span className="text-xs flex-shrink-0" style={{ color: 'var(--muted-foreground)' }}>
                {item?.time}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}